<template>
  <div style="background-color: #fbfbfb;">
    <top-navbar></top-navbar>
    <router-view></router-view>
    <MessageBox></MessageBox>
  </div>
</template>

<script>
import TopNavbar from './dashboard/TopNavbar.vue'
import MessageBox from '../components/MessageBox.vue'

export default {
  components: {
    TopNavbar,
    MessageBox
  },
  mounted() {
    document.querySelector('body').classList.add('has-navbar-fixed-top')
  }
}
</script>
